module.exports = __webpack_public_path__ + "static/media/17-2.cdcc7564.jpg";